import { MenuItem } from 'primeng/api'
export const AppMenu: MenuItem[] = [
    {
        label: 'Orders', routerLink: ['/welcome'], icon: 'pi pi-orders', id: '1', state: {
            userModules: ['orderentry']
        }
    },
    //analytics - will be populated dynamically
    {
        label: 'Analytics', icon: 'pi pi-analytics', id: '2', state: {
            userModules: ['analytics']
        },
        items: [] // Will be populated dynamically based on user modules
    },
    {
        label: 'TPV', routerLink: ['/tpv'], icon: 'pi pi-tpv', id: '3', state: {
            userModules: ['TPV']
        }
    },
    {
        // Internal SARA Plus admins only (Gateway grants the module)
        label: 'Best Buy Barcode', routerLink: ['/bestbuy-barcode'], icon: 'pi pi-barcode', id: '4', state: {
            userModules: ['BestBuyBarcode']
        }
    },
    {
        label: 'Settings', icon: 'pi pi-settings', id: '9',
        items: [
            {
                label: 'Time Entry', routerLink: ['/user/timeentry'], id: '9-2', state: {
                    userModules: ['CheckInCheckOutEntry']
                }
            },
            {
                label: 'User Management', routerLink: ['/user/usermanagement'], id: '9-3', state: {
                    userModules: ['UserManagement']
                }
            },
            {
                // Admins only (Gateway grants the module): portal feature toggles without a deployment
                label: 'Feature Toggles', routerLink: ['/feature-toggles'], id: '9-4', state: {
                    userModules: ['FeatureToggleAdmin']
                }
            }
        ]

    },
    {
        label: 'Live support', icon: 'pi pi-live-support', id: '99' // This has to be the max number because of it's positioning in the menu
    },
]